export default __webpack_public_path__ + "static/media/truck-04-thumbnail.e2881ee1.jpg";